module.exports = __webpack_public_path__ + "Pe-icon-7-filled.woff?b18b07ac92cbd0035eb0f5d04879e1b1";